import { render, staticRenderFns } from "./HExpert.vue?vue&type=template&id=4c208e2a&scoped=true&"
import script from "./HExpert.vue?vue&type=script&lang=js&"
export * from "./HExpert.vue?vue&type=script&lang=js&"
import style0 from "./HExpert.vue?vue&type=style&index=0&id=4c208e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c208e2a",
  null
  
)

export default component.exports